// extracted by mini-css-extract-plugin
export default {"iconHolder":"supportLevel_iconHolder__-C91Q","blankSpace":"supportLevel_blankSpace__jrVP9"};